module.exports = __webpack_public_path__ + "images/b6de3ddc621744e809dbb9f609f0170d.jpg";